<template>
  <v-textarea v-if="!readOnly && !field.readOnly"
              ref="inputRef"
              v-model="fieldValue"
              :required="maybeCall(field.required, value)"
              :prefix="field.prefix"
              :counter="maxLength"
              :maxlength="maxLength"
              :suffix="field.suffix"
              :return-masked-value="Boolean(field.mask)"
              :multi-line="field.multiLine"
              :hint="field.hint"
              :persistent-hint="true"
              :disabled="field.disabled"
              :rules="validationRules"
              :label="label"
              :type="fieldType"
              :class="field.class"
              :prepend-icon="field.prependIcon"
              :filled="box || field.box"
              @keyup.enter.stop
              @blur="onBlurTextField" />
  <div v-else :class="{'reg-information': !small, 'reg-information-small': small}">
    <label>{{ field.label }}</label>
    <p v-if="field.hint" class="text-caption primary--text">
      {{ field.hint }}
    </p>
    <p>{{ fieldValue || '-' }}</p>
  </div>
</template>

<script>
import { defineComponent, computed, toRef } from 'vue'
import { useDynamicField } from '../composables/useDynamicField'
import Utils from '~utils/utils'

export default defineComponent({
  name: 'DynamicTextArea',
  props: {
    value: {
      type: Object,
      default: () => ({})
    },
    field: {
      type: Object,
      required: true
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    box: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    isValidating: {
      type: Boolean,
      default: false
    },
    itemKey: {
      type: String,
      default: ''
    }
  },
  emits: ['input', 'change'],
  setup(props, { emit, expose }) {
    const {
      fieldValue,
      validationRules,
      label,
      inputRef,
      maybeCall,
      fieldChanged,
      hasError
    } = useDynamicField({
      value: toRef(props, 'value'),
      field: props.field,
      readOnly: props.readOnly,
      isValidating: toRef(props, 'isValidating'),
      itemKey: props.itemKey,
      emptyValue: '',
      emit
    })

    const fieldType = computed(() => {
      if (props.field.password) {
        return 'password'
      } else if (props.field.numericKeyboard) {
        return 'tel'
      } else {
        return 'text'
      }
    })

    const maxLength = computed(() => {
      if (props.field.maxLength && String(props.field.maxLength) !== '0') {
        return parseInt(String(props.field.maxLength))
      }
      return undefined
    })

    const onBlurTextField = () => {
      if (props.field.slug) {
        fieldValue.value = Utils.slugify(fieldValue.value)
        if (maxLength.value) {
          fieldValue.value = fieldValue.value.substr(0, maxLength.value)
        }
        fieldChanged(fieldValue.value)
      }
      fieldChanged(fieldValue.value)
    }

    // Expose properties for DynamicForm validation
    expose({
      hasError,
      validate: () => inputRef.value?.validate?.()
    })

    return {
      fieldValue,
      validationRules,
      label,
      inputRef,
      maybeCall,
      fieldType,
      maxLength,
      onBlurTextField
    }
  }
})
</script>

<style lang="scss">
</style>